<template>
  <div class="mystudio container-fluid">
    <div class="container-fluid">
      <div class="row" id="dashboardCardDiv">
        <div class="col-md-12">
          <div class="card card-transparent-background">
            <div class="card-header card-header-icon row">
              <div class="col-12 pl-0">
                <h4 class="card-title card-title-irish-date">Splash Screens</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
      <b-card no-body class="splashScreensCard p-3">
        <b-row>
          <b-col lg="4" md="6" class="splash-screen-container-mid">
            <p class="question-options-label-mid text-center">Welcome Screen</p>
            <div
              class="splash-screen-sample-mid mb-4"
              id="splashScreenWelcomeScreen"
              v-bind:style="{
                'background-image': 'url(' + preview_welcome_screen + ')',
              }"
            >
              <div class="splash-inputfile-div-mid">
                <input
                  type="file"
                  class="file-upload inputFileHidden d-none"
                  name="welcome_img"
                  id="welcome_img"
                  accept="image/*"
                  @change="previewImage($event, 'welcome_img')"
                />
                <div
                  class="splash-inputfile-btn-mid"
                  @click="addFile('welcome_img')"
                >
                  <p class="uploadFileP text-center">Upload image</p>
                </div>
              </div>
              <img
                src="@/assets/images/my-irish-date/logo-splash.png"
                class="d-block m-auto w-75 logo-img"
              />
              <div class="splash-content-mid">
                <p class="splash-content-text-mid">{{ welcome_screen_text }}</p>
              </div>
            </div>
            <b-form-group
              label="Edit text"
              label-for="welcome_screen_text"
              :welcome_screen_text="welcome_screen_text"
              label-class="form-label-mid form-label-question-mid"
            >
              <b-form-textarea
                id="welcome_screen_text"
                class="form-control-mid"
                v-model="welcome_screen_text"
                :title="welcome_screen_text"
                rows="5"
                >{{ welcome_screen_text }}</b-form-textarea
              >
            </b-form-group>
          </b-col>
          <b-col lg="4" md="6" class="splash-screen-container-mid">
            <p class="question-options-label-mid text-center">Login</p>
            <div
              class="splash-screen-sample-mid mb-4"
              id="splashScreenLoginScreen"
              v-bind:style="{
                'background-image': 'url(' + preview_login_screen + ')',
              }"
            >
              <div class="splash-inputfile-div-mid">
                <input
                  type="file"
                  class="file-upload inputFileHidden d-none"
                  name="login_img"
                  id="login_img"
                  accept="image/*"
                  @change="previewImage($event, 'login_img')"
                />
                <div
                  class="splash-inputfile-btn-mid"
                  @click="addFile('login_img')"
                >
                  <p class="uploadFileP text-center">Upload image</p>
                </div>
              </div>
              <img
                src="@/assets/images/my-irish-date/logo-splash.png"
                class="d-block m-auto w-75 logo-img"
              />
              <div class="splash-content-mid">
                <p class="splash-content-text-mid">{{ login_screen_text }}</p>

                <div
                  class="btn btn-bumblebee btn-mid btn-mid-primary w-100 p-2"
                >
                  Sign up
                </div>
                <div
                  class="
                    btn btn-bumblebee btn-mid btn-mid-transparent
                    w-100
                    p-2
                  "
                >
                  Login
                </div>
              </div>
            </div>
            <b-form-group
              label="Edit text"
              label-for="login_screen_text"
              :login_screen_text="login_screen_text"
              label-class="form-label-mid form-label-question-mid"
            >
              <b-form-textarea
                id="login_screen_text"
                class="form-control-mid"
                v-model="login_screen_text"
                :title="login_screen_text"
                rows="5"
                >{{ login_screen_text }}</b-form-textarea
              >
            </b-form-group></b-col
          >
          <b-col lg="4" md="6" class="splash-screen-container-mid">
            <p class="question-options-label-mid text-center">
              Welcome Screen 2
            </p>
            <div
              class="splash-screen-sample-mid mb-4"
              id="splashScreenWelcome2Screen"
              v-bind:style="{
                'background-image': 'url(' + preview_welcome_screen_2 + ')',
              }"
            >
              <div class="splash-inputfile-div-mid">
                <input
                  type="file"
                  class="file-upload inputFileHidden d-none"
                  name="welcome2_img"
                  id="welcome2_img"
                  accept="image/*"
                  @change="previewImage($event, 'welcome2_img')"
                />
                <div
                  class="splash-inputfile-btn-mid"
                  @click="addFile('welcome2_img')"
                >
                  <p class="uploadFileP text-center">Upload image</p>
                </div>
              </div>
              <div class="splash-content-img-mid">
                <p class="splash-content-text-mid text-center mb-2">
                  Welcome To
                </p>

                <img
                  src="@/assets/images/my-irish-date/logo-splash.png"
                  class="d-block m-auto w-75 logo-img"
                />
                <p class="splash-content-text-mid text-center mt-3">
                  {{ welcome_screen2_text }}
                </p>
              </div>
              <div class="splash-content-mid">
                <div
                  class="btn btn-bumblebee btn-mid btn-mid-primary w-100 p-2"
                >
                  Start
                </div>
              </div>
            </div>
            <b-form-group
              label="Edit text"
              label-for="welcome_screen2_text"
              :welcome_screen2_text="welcome_screen2_text"
              label-class="form-label-mid form-label-question-mid"
            >
              <b-form-textarea
                id="welcome_screen2_text"
                class="form-control-mid"
                v-model="welcome_screen2_text"
                :title="welcome_screen2_text"
                rows="5"
                >{{ welcome_screen2_text }}</b-form-textarea
              >
            </b-form-group></b-col
          >
        </b-row> </b-card
      ><b-row>
        <b-col lg="3" offset-lg="9" md="4" offset-md="8" sm="6" offset-sm="6">
          <b-button
            type="button"
            variant="mid-primary"
            class="btn-bumblebee btn-mid btn-mid-submit w-100"
            @click="clickSaveChanges"
            v-if="!is_loading"
            >Save changes
          </b-button>
          <b-button
            type="button"
            disabled
            variant="mid-primary"
            class="btn-bumblebee btn-mid btn-mid-submit w-100"
            v-else
          >
            <b-spinner small label="Small Spinner" variant="light"></b-spinner>
            Loading
          </b-button>
        </b-col></b-row
      >
    </div>
  </div>
</template>
      
<script>
import $, { event } from "jquery";

export default {
  name: "MIDSplashScreens",

  data() {
    return {
      preview_welcome_screen: require("@/assets/images/my-irish-date/welcome_screen.png"),
      preview_login_screen: require("@/assets/images/my-irish-date/login-background.png"),
      preview_welcome_screen_2: require("@/assets/images/my-irish-date/welcome_screen.png"),
      welcome_screen_text:
        "Join your tribe, meet your Irish match and have the craic!",
      login_screen_text:
        "Create your profile see someone you like and swipe... g'wan ya good thing get chattin!",
      welcome_screen2_text: "Let the fun begin",
      welcome_img: null,
      login_img: null,
      welcome2_img: null,
      is_loading: false,
    };
  },
  mounted() {},
  created() {},
  methods: {
    previewImage: function (e, id) {
      console.log("preview img " + id);
      console.log(e);
      var input = e.target;
      if (input.files) {
        var reader = new FileReader();
        reader.readAsDataURL(input.files[0]);
        reader.onload = (e) => {
          //   this.preview = e.target.result;
          if (id === "welcome_img") {
            this.preview_welcome_screen = e.target.result;
          } else if (id === "login_img") {
            this.preview_login_screen = e.target.result;
          } else if (id === "welcome2_img") {
            this.preview_welcome_screen_2 = e.target.result;
          }
        };
        if (id === "welcome_img") {
          this.welcome_img = e.target.files[0];
        } else if (id === "login_img") {
          this.login_img = e.target.files[0];
        } else if (id === "welcome2_img") {
          this.welcome2_img = e.target.files[0];
        }
        // this.cover_image = e.target.files[0];
        // console.log(this.cover_image);
      }
    },
    addFile(id) {
      console.log("click file " + id);
      $("#" + id).click();
    },
    clickSaveChanges() {
      this.is_loading = true;
      console.log("save changes ");
      console.log(this.welcome_screen_text);
      console.log(this.welcome_img);
      console.log(this.login_screen_text);
      console.log(this.login_img);
      console.log(this.welcome_screen2_text);
      console.log(this.welcome2_img);
      var temp = this;
      setTimeout(function () {
        temp.is_loading = false;
      }, 2000);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/my_irish_date/SplashScreens.vue